import axiosInstance from "../configs/axios.config";

const SERVER = import.meta.env.VITE_API_URL;

export const getDashboardData = async () => {
  const token = localStorage.getItem("prima_session");
  if (!token) throw new Error("Unauthorized user");

  try {
    const response = await axiosInstance.get(`${SERVER}/admin/dashboard`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      throw new Error("Unauthorized user");
    }
    throw new Error(
      error.response?.data?.message || "Failed to fetch dashboard",
    );
  }
};
